import { useSelector } from 'react-redux';

import appSelectors from '@/redux/app/appSelectors';

import s from './noData.module.css';

const translate = {
  'Нет данных...': {
    RU: 'Нет данных...',
    EN: 'No data...',
  },
};

function NoData() {
  const lang = useSelector(appSelectors.language);

  return (
    <div className={s.no_data}>
      <div className={s.image} />
      <p className={s.text}>{translate['Нет данных...'][lang]}</p>
    </div>
  );
}

export default NoData;
